// MobileFooter.tsx (Image/Preview 모두 첫 클릭 시 전환되도록 수정)

import { useState } from "react";

import {
  Tabs,
  TabsList,
  TabsTrigger,
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
} from "@upstageai/ui";

import { Icon, Icons } from "../components/Icon";
import {
  getEndpointViewTypes,
  getViewLabel,
  ViewType,
} from "../constants/EndpointViews";
import { MenuItems } from "./menu/MenuItems";
import { endpointStore } from "../utils/mobx/EndpointStore";
import { cn } from "../utils/style";
import ResultDownloadButton from "./result-file/ResultDownloadButton";

export type MobileViewMode = "image" | "result";

export interface MobileViewConfig {
  mode: MobileViewMode;
  resultView: ViewType;
}

interface MobileFooterProps {
  viewConfig: MobileViewConfig;
  setViewConfig: (config: MobileViewConfig) => void;
}

const MobileFooter = ({ viewConfig, setViewConfig }: MobileFooterProps) => {
  const { endpointType } = endpointStore;
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const viewTypes = getEndpointViewTypes(endpointType);

  const { mode, resultView } = viewConfig;

  const showDownloadButton = viewConfig.mode === "result";

  const handlePreviewClick = (e: React.MouseEvent) => {
    if (mode !== "result") {
      setViewConfig({ ...viewConfig, mode: "result" });
      setDropdownOpen(false);
    } else {
      e.preventDefault();
      setDropdownOpen(prev => !prev);
    }
  };

  return (
    <section className="fixed bottom-0 left-0 right-0 z-10 flex h-mobile-footer items-center justify-between border-t border-border bg-background px-4 mobile:flex desktop:hidden">
      <div className="flex gap-1.5">
        <Tabs value={mode}>
          <TabsList className="gap-2">
            <TabsTrigger
              value="image"
              onClick={() => {
                setViewConfig({ ...viewConfig, mode: "image" });
                setDropdownOpen(false);
              }}
            >
              Image
            </TabsTrigger>

            <DropdownMenu open={dropdownOpen} onOpenChange={setDropdownOpen}>
              <DropdownMenuTrigger asChild>
                <TabsTrigger
                  value="result"
                  onClick={handlePreviewClick}
                  className={cn(
                    "flex items-center gap-1",
                    mode === "result" &&
                      "bg-surface text-surface-foreground shadow",
                  )}
                >
                  {getViewLabel(resultView)}
                  {mode === "result" && (
                    <Icon source={Icons.ChevronDown} className="size-4" />
                  )}
                </TabsTrigger>
              </DropdownMenuTrigger>

              {mode === "result" && (
                <DropdownMenuContent
                  align="start"
                  sideOffset={8}
                  className="w-32"
                >
                  {viewTypes.map(viewType => (
                    <DropdownMenuItem
                      key={viewType}
                      onSelect={() => {
                        setViewConfig({
                          mode: "result",
                          resultView: viewType,
                        });
                        setDropdownOpen(false);
                      }}
                      className={cn(
                        resultView === viewType && "bg-muted-light font-medium",
                      )}
                    >
                      {getViewLabel(viewType)}
                    </DropdownMenuItem>
                  ))}
                </DropdownMenuContent>
              )}
            </DropdownMenu>
          </TabsList>
        </Tabs>
      </div>
      <div className="flex gap-1.5">
        {showDownloadButton && (
          <ResultDownloadButton
            viewType={viewConfig.resultView}
            buttonVariant="outline"
          />
        )}
        <MenuItems />
      </div>
    </section>
  );
};

export default MobileFooter;
